<template>
  <div class="infoBox">
    <div class="jdTitle">
      <div class="leftInfo">
        <div class="jdmc">{{ detail.jdmc }}</div>
        <div class="jdmcEn">{{ detail.jdmcEn }}</div>
      </div>
      <div class="lxkf" style="padding-left:24px">
        <div class="blueBg">
          <img width="7px" height="7px" src="../../../assets/image/phone.png" alt="">
        </div>
        <div style="font-size: 12px;padding-left: 12px">
          联系电话 <a href="javascript:;">{{detail.phone}}</a>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 100%;">
      <div class="title">
        酒店介绍
      </div>
      <div class="content" v-html="detail.introEditor"></div>
      <div class="title" >
        订房必读
      </div>
      <div class="title" style="font-size: 12px">
        入离时间
      </div>
      <div class="content" >
        <span class="ht-text" v-if="detail.arrivalTime && detail.departureTime">入住时间:{{ detail.arrivalTime }}后，退房时间:{{ detail.departureTime }}前</span>
        <span class="ht-text" v-else>无</span>
      </div>
      <div class="title" style="font-size: 12px">
        城市通知
      </div>
      <div class="content" >
        <span class="ht-text" v-if="cityNotice" v-html="cityNotice" ></span>
        <span class="ht-text" v-else>无</span>
      </div>
      <div class="title" style="font-size: 12px">
        酒店提示
      </div>
      <div class="content">
        <text class="ht-text" v-if="hotelNotice" v-html="hotelNotice" ></text>
        <text class="ht-text" v-else>无</text>
      </div>
      <div class="title" >
        酒店设施
      </div>
      <div class="content">
          <div style="width: 100%" v-for="faGroup in detail.facilityGroupList" :key="faGroup">
            <div class="title">
              {{ faGroup.facilitieTypeName }}
            </div>
            <div class="cxr_item_content" >
              <div class="cxr_item_def" v-for="item in faGroup.hotelFacilityList" :key="item.empId">
                {{ item.facilitieName}}
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    detail:{
      type:Object,
      default:() => {
        return {}
      }
    }
  },
  data(){
    return {

    }
  },
  computed: {
    cityNotice() {
      console.log(this.$props.detail,'this.$props.detail')
      if (this.$props.detail.bookingNoticeList && this.$props.detail.bookingNoticeList.length > 0) {
        let arr = this.$props.detail.bookingNoticeList.filter(item => item.category == 'City')
        if (arr.length > 0) {
          let item = arr[0];
          if (item.noticeStart && item.noticeEnd) {
            return `${arr[0].text})(提示有效期：${item.noticeStart}至${item.noticeEnd})`
          }
          return `${arr[0].text}`
        } else {
          return ''
        }
      }else{
        return ''
      }
    },
    hotelNotice(){
      if(this.$props.detail.bookingNoticeList && this.$props.detail.bookingNoticeList.length>0){
        let arr = this.$props.detail.bookingNoticeList.filter(item => item.category == 'Hotel')
        if(arr.length >0){
          return `${arr[0].text})(提示有效期：${item.noticeStart}至${item.noticeEnd})`
         }else{
          return ''
        }
      }else{
        return ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.infoBox{
  width: 100%;
  height: 100%;
  text-align: left;
  .jdTitle{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .leftInfo{
        .jdmc{
          font-size: 20px;
          font-weight: 600;
        }
      .jdmcEn{
        font-size: 10px;
        color: #222;
      }
    }
    .lxkf{
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .blueBg{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: url("../../../assets/image/blueBg.png") 100% 100% no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .title{
    font-size: 14px;
    font-weight: 600;
    padding: 12px 0;
  }
  .content{
    font-size: 12px;
    color: #666;
  }
  .cxr_item_content{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }
  .cxr_item_def{
    flex-shrink: 0;
    width: 24%;
    height: 27px;
    line-height: 27px;
    padding-left: 4px;
    text-align: left;
    font-size: 12px;
    color: #666;
    border: 1px solid #f2f2f2;
  }
}


</style>
